import { PaymentCardProviderDTO } from '../dto/payment-card-provider.dto';
import { PAYMENT_CARD_PROVIDER_TYPES } from './payment-card-provider-type';

export class PaymentCardProvider {
  public name: string;
  public id: number;
  public type: number;

  public static convertFromDTO(
    paymentCardProviderDTO: PaymentCardProviderDTO
  ): PaymentCardProvider {
    let paymentCardProvider: PaymentCardProvider = new PaymentCardProvider();
    if (paymentCardProviderDTO) {
      paymentCardProvider.name = paymentCardProviderDTO.name;
      paymentCardProvider.id = paymentCardProviderDTO.oid;
      paymentCardProvider.type = paymentCardProviderDTO.paymentCardProvider;
    } else {
      paymentCardProvider = null;
    }
    return paymentCardProvider;
  }

  public static isFirstData(paymentCardProvider: PaymentCardProvider): boolean {
    return paymentCardProvider.type === PAYMENT_CARD_PROVIDER_TYPES.FIRST_DATA;
  }

  public static isMoneris(paymentCardProvider: PaymentCardProvider): boolean {
    return paymentCardProvider.type === PAYMENT_CARD_PROVIDER_TYPES.MONERIS;
  }

  public static isVantivDirect(
    paymentCardProvider: PaymentCardProvider
  ): boolean {
    return (
      paymentCardProvider.type === PAYMENT_CARD_PROVIDER_TYPES.VANTIV_DIRECT
    );
  }

  // Note that vantiv dejavoo has same pcp type as first data. The difference is the autoCapture time,
  // this is set to -40 for vantivDejavoo. We dont need it so it's not added but info is valuable nonetheless.
  public static isVantivDejavoo(
    paymentCardProvider: PaymentCardProvider
  ): boolean {
    return (
      paymentCardProvider.type === PAYMENT_CARD_PROVIDER_TYPES.VANTIV_DEJAVOO
    );
  }

  public static isLightspeedPayment(
    paymentCardProvider: PaymentCardProvider
  ): boolean {
    return paymentCardProvider.type === PAYMENT_CARD_PROVIDER_TYPES.LIGHTSPEED;
  }

  public static isLightspeedPaymentsAdyen(
    paymentCardProvider: PaymentCardProvider
  ): boolean {
    return (
      paymentCardProvider.type === PAYMENT_CARD_PROVIDER_TYPES.LIGHTSPEED_ADYEN
    );
  }

  public static isLightspeedPaymentsCayan(
    paymentCardProvider: PaymentCardProvider
  ): boolean {
    return paymentCardProvider.type === PAYMENT_CARD_PROVIDER_TYPES.LSPAY_CAYAN;
  }
}
